import { Check, X } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const features = [
  { feature: "Monthly cost per employee", trueWellness: "$74-199", noom: "$209+", insurance: "$1,000+" },
  { feature: "Prescription GLP-1s", trueWellness: true, noom: true, insurance: "Limited" },
  { feature: "Custom peptides", trueWellness: true, noom: false, insurance: false },
  { feature: "Telehealth included", trueWellness: true, noom: true, insurance: false },
  { feature: "Community events", trueWellness: true, noom: false, insurance: false },
  { feature: "Peer support groups", trueWellness: true, noom: false, insurance: false },
  { feature: "Implementation time", trueWellness: "<2 weeks", noom: "4-6 weeks", insurance: "3-6 months" },
  { feature: "Insurance hassles", trueWellness: "None", noom: "None", insurance: "Extensive" },
  { feature: "Employer dashboard", trueWellness: true, noom: "Limited", insurance: false },
];

const renderValue = (value: boolean | string) => {
  if (value === true) {
    return <Check className="w-5 h-5 text-green-500 mx-auto" />;
  }
  if (value === false) {
    return <X className="w-5 h-5 text-red-400 mx-auto" />;
  }
  return <span className="text-gray-700">{value}</span>;
};

const ComparisonTable = () => {
  return (
    <section className="py-20 md:py-28 bg-[#0D1B2A] relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(rgba(255,219,77,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,219,77,0.5) 1px, transparent 1px)`,
        backgroundSize: '40px 40px'
      }} />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-14">
          <h2 className="text-sm font-bold text-[#ffdb4d] uppercase tracking-[0.2em] mb-4">Head-to-Head Comparison</h2>
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 tracking-tight">
            True Wellness vs. Traditional Solutions
          </h3>
          <p className="text-lg text-white/70 max-w-2xl mx-auto">See why leading organizations choose us over legacy wellness providers</p>
        </div>

        <Card className="max-w-5xl mx-auto overflow-hidden shadow-2xl border-0 rounded-2xl">
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-[#0D1B2A] via-[#1B3A4B] to-[#0D1B2A]">
                    <th className="text-left py-5 px-6 text-white font-semibold text-base">Feature</th>
                    <th className="text-center py-5 px-6">
                      <div className="bg-[#ffdb4d] text-[#0D1B2A] font-bold px-4 py-2 rounded-lg inline-block">True Wellness</div>
                    </th>
                    <th className="text-center py-5 px-6 text-white/80 font-semibold">Noom Med</th>
                    <th className="text-center py-5 px-6 text-white/80 font-semibold">Insurance Coverage</th>
                  </tr>
                </thead>
                <tbody>
                  {features.map((row, index) => (
                    <tr 
                      key={index} 
                      className={`border-b border-gray-100 hover:bg-gray-50 transition-colors ${index % 2 === 0 ? "bg-gray-50/50" : "bg-white"}`}
                    >
                      <td className="py-5 px-6 text-[#0D1B2A] font-semibold">{row.feature}</td>
                      <td className="py-5 px-6 text-center bg-[#ffdb4d]/10 font-semibold text-[#0D1B2A]">
                        {renderValue(row.trueWellness)}
                      </td>
                      <td className="py-5 px-6 text-center text-gray-600">{renderValue(row.noom)}</td>
                      <td className="py-5 px-6 text-center text-gray-600">{renderValue(row.insurance)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ComparisonTable;
